import { PdfDeliveryFormType } from '../enums/pdf-delivery-form-type.enum';

export class PdfDeliveryFormTypeHelper {
  private static readonly LABELS: Record<PdfDeliveryFormType, string> = {
    [PdfDeliveryFormType.DeliveryFormWithParams]: 'BL',
    [PdfDeliveryFormType.DeliveryFormWithAmount]: 'BL avec montants + DMSM',
    [PdfDeliveryFormType.DeliveryFormWithoutAmount]: 'BL sans montant + DMSM',
    [PdfDeliveryFormType.DeliveryFormWithAndWithoutAmount]: 'BL avec et sans montants + DMSM',
    [PdfDeliveryFormType.DeliveryFormDMSMAndTraceability]: 'Déclaration DMSM et traçabilité',
    [PdfDeliveryFormType.DeliveryFormLabelTag89x28]: 'Etiquette de livraison (89x28mm)',
    [PdfDeliveryFormType.DeliveryFormLabelTag23x23]: 'Etiquette de livraison (23x23mm)',
    [PdfDeliveryFormType.DeliveryFormOnlyWithAmount]: 'BL seul avec montants',
    [PdfDeliveryFormType.DeliveryFormOnlyWithoutAmount]: 'BL seul sans montant',
    [PdfDeliveryFormType.DeliveryFormOnlyWithAndWithoutAmount]: 'BL seul avec et sans montants',
  };

  private static readonly LABELS_PLURAL: Record<PdfDeliveryFormType, string> = {
    [PdfDeliveryFormType.DeliveryFormWithParams]: 'BL',
    [PdfDeliveryFormType.DeliveryFormWithAmount]: 'BL avec montants + DMSM',
    [PdfDeliveryFormType.DeliveryFormWithoutAmount]: 'BL sans montant + DMSM',
    [PdfDeliveryFormType.DeliveryFormWithAndWithoutAmount]: 'BL avec et sans montants + DMSM',
    [PdfDeliveryFormType.DeliveryFormDMSMAndTraceability]: 'Déclarations DMSM et traçabilité',
    [PdfDeliveryFormType.DeliveryFormLabelTag89x28]: 'Etiquettes de livraison (89x28mm)',
    [PdfDeliveryFormType.DeliveryFormLabelTag23x23]: 'Etiquettes de livraison (23x23mm)',
    [PdfDeliveryFormType.DeliveryFormOnlyWithAmount]: 'BL seuls avec montants',
    [PdfDeliveryFormType.DeliveryFormOnlyWithoutAmount]: 'BL seuls sans montant',
    [PdfDeliveryFormType.DeliveryFormOnlyWithAndWithoutAmount]: 'BL seuls avec et sans montants',
  };

  public static buildPdfMergeNotificationCardMessage(length: number, pdfDocumentType: PdfDeliveryFormType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };
    if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormWithParams) {
      msg = {
        msgPlural: `PDF de ${length} bons de livraison`,
        msgSingular: `PDF de ${length} bon de livraison`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormWithAmount) {
      msg = {
        msgPlural: `PDF de ${length} BL avec montants + DMSM`,
        msgSingular: `PDF de ${length} BL avec montants + DMSM`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormWithoutAmount) {
      msg = {
        msgPlural: `PDF de ${length} BL sans montant + DMSM`,
        msgSingular: `PDF de ${length} BL sans montant + DMSM`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormWithAndWithoutAmount) {
      msg = {
        msgPlural: `PDF de ${length} BL avec et sans montants + DMSM`,
        msgSingular: `PDF de ${length} BL avec et sans montants + DMSM`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormDMSMAndTraceability) {
      msg = {
        msgPlural: `PDF de ${length} déclarations DMSM et traçabilité`,
        msgSingular: `PDF de ${length} déclaration DMSM et traçabilité`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormLabelTag89x28) {
      msg = {
        msgPlural: `PDF de ${length} étiquettes de livraison`,
        msgSingular: `PDF de ${length} étiquette de livraison`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormLabelTag23x23) {
      msg = {
        msgPlural: `PDF de ${length} étiquettes de livraison`,
        msgSingular: `PDF de ${length} étiquette de livraison`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormOnlyWithAmount) {
      msg = {
        msgPlural: `PDF de ${length} BL seuls avec montants`,
        msgSingular: `PDF de ${length} BL seul avec montants`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormOnlyWithoutAmount) {
      msg = {
        msgPlural: `PDF de ${length} BL seuls sans montant`,
        msgSingular: `PDF de ${length} BL seul sans montant`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormOnlyWithAndWithoutAmount) {
      msg = {
        msgPlural: `PDF de ${length} BL seuls avec et sans montants`,
        msgSingular: `PDF de ${length} BL seul avec et sans montants`,
      };
    } else {
      msg = {
        msgPlural: `PDF de ${length} bons de livraison`,
        msgSingular: `PDF de ${length} bon de livraison`,
      };
    }
    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static buildPdfMergeNotifyMessage(length: number, pdfDocumentType: PdfDeliveryFormType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };
    if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormWithParams) {
      msg = {
        msgPlural: `PDF multiple de ${length} bons de livraison en cours de génération`,
        msgSingular: `PDF multiple de ${length} bon de livraison en cours de génération`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormWithAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} BL avec montants + DMSM en cours de génération`,
        msgSingular: `PDF multiple de ${length} BL avec montants + DMSM en cours de génération`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormWithoutAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} BL sans montant + DMSM en cours de génération`,
        msgSingular: `PDF multiple de ${length} BL sans montant + DMSM en cours de génération`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormWithAndWithoutAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} BL avec et sans montants + DMSM en cours de génération`,
        msgSingular: `PDF multiple de ${length} BL avec et sans montants + DMSM en cours de génération`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormDMSMAndTraceability) {
      msg = {
        msgPlural: `PDF multiple de ${length} déclarations DMSM et traçabilité`,
        msgSingular: `PDF multiple de ${length} déclaration DMSM et traçabilité`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormLabelTag89x28) {
      msg = {
        msgPlural: `PDF multiple de ${length} étiquettes de livraison  en cours de génération`,
        msgSingular: `PDF multiple de ${length} étiquette de livraison  en cours de génération`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormLabelTag23x23) {
      msg = {
        msgPlural: `PDF multiple de ${length} étiquettes de livraison  en cours de génération`,
        msgSingular: `PDF multiple de ${length} étiquette de livraison  en cours de génération`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormOnlyWithAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} BL seuls avec montants en cours de génération`,
        msgSingular: `PDF multiple de ${length} BL seul avec montants en cours de génération`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormOnlyWithoutAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} BL seuls sans montant en cours de génération`,
        msgSingular: `PDF multiple de ${length} BL seul sans montant en cours de génération`,
      };
    } else if (pdfDocumentType === PdfDeliveryFormType.DeliveryFormOnlyWithAndWithoutAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} BL seuls avec et sans montants en cours de génération`,
        msgSingular: `PDF multiple de ${length} BL seul avec et sans montants en cours de génération`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static translateEnum(enumValue: PdfDeliveryFormType, pluralFlag = false): string | undefined {
    return (pluralFlag ? this.LABELS_PLURAL : this.LABELS)[enumValue] ?? undefined;
  }
}
